import { Flex } from '@chakra-ui/react';
import { memo } from 'react';

import Welcome from '@features/home/Welcome';

const HomePage = () => {
  return (
    <Flex
      w="100%"
      h="100%"
      alignItems="center"
      justifyContent="center"
      flexDir="column"
      pt={16}
      px={4}
    >
      <Welcome />
    </Flex>
  );
};

export default memo(HomePage);
